import { Rating } from "@mui/material";
import React from "react";
import ReactDOM from "react-dom/client";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import "./App.css";
import grangesImage from "./bilder/gränges.jpg";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

export interface BeerData {
  name: string;
  caption: string;
  rating: number;
  imgSource: string;
  percentage: number;
}

interface BeerCardsGalleryProps {
  selectedCategory: number;
  selectedSort: number;
}

const beers: BeerData[] = [
  {
    name: "Falcon 3,5%",
    caption:
      "Riktigt stabil, smakrik och har minimal folkissmak. Bättre än starkölen",
    rating: 5,
    imgSource: "/bilder/falcon.PNG",
    percentage: 3,
  },
  {
    name: "Sir Taste-a-Lot 3,5%",
    caption: "En lager med mycket karaktär av humle, riktigt god!",
    rating: 5,
    imgSource: "/bilder/testealot.png",
    percentage: 3,
  },
  {
    name: "Erdinger Weissbräu 0,4%",
    caption: "Otroligt god alkoholfri öl. Bästa du kan hitta!",
    rating: 5,
    imgSource: "/bilder/erdinger.png",
    percentage: 0,
  },
  {
    name: "Pistonhead Flat Tire 3,5%",
    caption: "Precis som sarkölen har denna mycket smak och karaktär. En av dem bästa här!",
    rating: 5,
    imgSource: "/bilder/piston.png",
    percentage: 3,
  },
  {
    name: "Eriksberg 3,5%",
    caption: "Kittlar smaklökarna på ett mycket behagligt sätt!",
    rating: 5,
    imgSource: "/bilder/erik.png",
    percentage: 3,
  },
  {
    name: "Heineken 3,5%",
    caption: "Smakar nästan identiskt med starkisen. Väldigt trevlig.",
    rating: 4,
    imgSource: "/bilder/heineken.png",
    percentage: 3,
  },
  {
    name: "Gränges 2,1%",
    caption: "En förvånansvärt god öl för att endast vara en lättis.",
    rating: 4,
    imgSource: "/bilder/gränges.jpg",
    percentage: 2,
  },
  { name: "Pripps Blå 2,2%",
    caption: "En mycket trevlig lättis! Standard ingår-i-lunchen-öl",
    rating: 4,
    imgSource: "/bilder/pripps2.PNG",
    percentage: 2,
  },
  {
    name: "Staropramen 3,5%",
    caption: "Smakrik folkis med karaktär av en starköl.",
    rating: 4,
    imgSource: "/bilder/staro.png",
    percentage: 3,
  },
  { name: "The Mad Canary Session IPA 3,5%",
    caption: "En helt ok IPA-folkis, inget speciellt.",
    rating: 3,
    imgSource: "/bilder/canary.png",
    percentage: 3,
  },
  {
    name: "Norrlands Ljus 3,5%",
    caption: "Smakar typ exakt som den vanliga. Saknas ju bara 1,2%",
    rating: 3,
    imgSource: "/bilder/ljus.png",
    percentage: 3,
  },
  {
    name: "Spendrups 2,8%",
    caption: "Medelgod smak, men helt klart njutbar.",
    rating: 3,
    imgSource: "/bilder/spendrups.PNG",
    percentage: 2,
  },
  {
    name: "Carlsberg 3,5%",
    caption: "Helt okej, lite godare än andra men annars tråkig",
    rating: 3,
    imgSource: "/bilder/carl.jpg",
    percentage: 3,
  },
  {
    name: "Mariestad 3,5%",
    caption: "Tråkig smak, god men hade hellre valt något annat.",
    rating: 3,
    imgSource: "/bilder/mariestad.jpg",
    percentage: 3,
  },
  {
    name: "Easy Rider Bulldog 0,4%",
    caption: "Alkoholfri IPA? Helt okej men en hög tvåa på denna.",
    rating: 2,
    imgSource: "/bilder/Easy.png",
    percentage: 0,
  },
  {
    name: "Motörhead 0,5%",
    caption: "Kickstart my... Nae, den startar inte mycket. Tråkig.",
    rating: 2,
    imgSource: "/bilder/motör.PNG",
    percentage: 0,
  },
  {
    name: "Zebra Zwag Lager 3,5%",
    caption: "Tropical Lager kallar den sig själv, men stark lagersmak plus fanta-exotic va inte jättegott...",
    rating: 2,
    imgSource: "/bilder/zebra.PNG",
    percentage: 3,
  },
  {
    name: "Burgenfels 2,8%",
    caption: "Mettallisk smak, men ändå med lite karaktär.",
    rating: 2,
    imgSource: "/bilder/burg.PNG",
    percentage: 2,
  },
  {
    name: "Norrlands Guld 3,5%",
    caption: "Rätt mid, inget speciellt.",
    rating: 2,
    imgSource: "/bilder/norrlands.jpg",
    percentage: 3,
  },
  {
    name: "Emdbräu 2,25%",
    caption: "Inte jättegod, lämnar en unken metallisk eftersmak...",
    rating: 1,
    imgSource: "/bilder/emdbrau.PNG",
    percentage: 2,
  },
  {
    name: "Sofiero 3,5%",
    caption:
      "Fruktansvärd. Smakar lika äckligt som en borta match mot Häcken. Kan va för att dem serverar just denna skiten...",
    rating: 1,
    imgSource: "/bilder/sofiero.png",
    percentage: 3,
  },
];

const BeerCardsGallery: React.FC<BeerCardsGalleryProps> = ({
  selectedCategory,
  selectedSort,
}) => {
  const filteredBeers = beers
    .filter((beer) => {
      if (selectedCategory === 1) return true; // Alla
      if (selectedCategory === 2) return beer.percentage >= 3; // Folkisar
      if (selectedCategory === 3) return beer.percentage < 3 && beer.percentage > 1 ; // Lättisar
      if (selectedCategory === 4) return beer.percentage == 0; // Alkoholfri
      return false;
    })
    .sort((a, b) => {
      if (selectedSort === 1) return b.rating - a.rating; // Högst till Lägst
      if (selectedSort === 2) return a.rating - b.rating; // Lägst till Högst
      return 0; // Ingen sortering
    }); // Added sorting logic

  return (
    <div className="beerContainer">
      {filteredBeers.map((beer, index) => (
        <main key={index}>
          <div className="beerCards">
            <Card sx={{ maxWidth: 300, maxHeight: 600, padding: 0 }}>
              <div className="beerCards">
                <CardMedia
                  component="img"
                  alt={beer.name}
                  height="300"
                  image={beer.imgSource}
                  sx={{ padding: "0", objectFit: "contain" }}
                />
              </div>
              <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                  {beer.name}
                </Typography>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  {beer.caption}
                </Typography>
                <div className="rating">
                  <Rating name="read-only" value={beer.rating} readOnly />
                </div>
              </CardContent>
            </Card>
          </div>
        </main>
      ))}
    </div>
  );
};

root.render(
  <React.StrictMode>
    <BeerCardsGallery selectedCategory={1} selectedSort={0} />
  </React.StrictMode>
);

export default BeerCardsGallery;
